import {
  call, put, select, takeLatest, all
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions, actionCreators } from 'react/api/actions/crud';

function* fetchInitialFormValuesApi(id, entity, customCriteria, customCriteriaChain = null) {
  let criteria = yield select((state) => (
    state.crud ? state.crud.getIn([entity, 'criteria']) : Object.keys(state.form[entity].registeredFields)
  ));
  const criteriaChain = {
    criteriaChain: [{ and: [{ attr: 'id', eq: id }] }],
    firstResult: 0,
    maxResults: 1
  };

  if (customCriteria.length) {
    criteria = customCriteria.reduce((acc, item) => {
      if (acc.indexOf(item) === -1) {
        return acc.push(item);
      }
      return acc;
    }, criteria);
  }
  const data = customCriteriaChain || criteriaChain;
  const url = `/${entity}/restrictions?criteria={"filters":${JSON.stringify(criteria)}}`;
  const encodedUrl = encodeURI(url);
  return yield call(defaultFetch, encodedUrl, data, 'POST');
}

function* fetchInitialFormValuesSaga(action) {
  const {
    id, entity, goToGrid, customCriteria, customCriteriaChain
  } = action.payload;
  const response = yield call(
    fetchInitialFormValuesApi, id, entity, customCriteria, customCriteriaChain
  );
  const { error } = response;
  if (!error) {
    yield put(actionCreators.fetchInitialFormValuesSuccess({ values: response, entity }));
  } else {
    goToGrid();
  }
}

function* watchFetchInitialFormValues() {
  yield takeLatest(actions.fetchInitialFormValues, fetchInitialFormValuesSaga);
}

export function* saveFormApi(id, entity, data, updateMethod) {
  const body = (id && updateMethod !== 'PUT') ? { id, ...data } : data;
  const method = id ? updateMethod : 'POST';
  const url = `/${entity}${(id && updateMethod === 'PUT') ? `/${id}` : ''}`;
  const encodedUrl = encodeURI(url);
  return yield call(defaultFetch, encodedUrl, body, method);
}

function* saveFormSaga(action) {
  const {
    id,
    entity,
    updateMethod,
    data,
    afterSubmit
  } = action.payload;
  const response = yield call(saveFormApi, id, entity, data, updateMethod);
  const payload = { ...response, entity };
  if (!response.error) {
    yield put(actionCreators.saveFormSuccess(payload));
    afterSubmit && afterSubmit({
      formData: data,
      successPayload: payload
    });
  } else {
    yield put(actionCreators.saveFormError(payload));
  }
}

function* watchSaveForm() {
  yield takeLatest(actions.saveForm, saveFormSaga);
}

function* clearFormDataSaga(action) {
  const { entity } = action.payload;

  if (entity) {
    yield put({
      type: '@@redux-form/DESTROY',
      meta: {
        form: [entity]
      }
    });
  }
}

function* watchClearFormData() {
  yield takeLatest(actions.clearFormState, clearFormDataSaga);
}

export default function* () {
  yield all([
    watchFetchInitialFormValues(),
    watchSaveForm(),
    watchClearFormData()
  ]);
}
